import React, { Suspense, useContext } from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { AppContextProvider } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/custom.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Loader from "./components/Loader";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Auth/Home";
import Profile from "./pages/Auth/Profile";
import SignIn from "./pages/Auth/SignIn";
import Error from "./pages/Error";
import {
  CmsManagement,
  CustomerView,
  Customer,
  Notifications,
  Transaction,
  SubAdmin,
  RoleManagement,
  Leaderboard,
  Merchandize,
  Coupon,
  UserChallenge,
  Feed,
  Support,
  Attribute,
  Product,
  Category,
  MediaContent,
  ViewLogs,
  Order,
  ViewProduct,
  ViewPredefined
} from "./pages";
import Subscription from "./pages/Subscription/Index"
import EmailEdit from "./pages/EmailTemplate/Edit";
import EmailTemplate from "./pages/EmailTemplate/Index";
import Privacy_policy from "./pages/Auth/PrivacyPolicy";
import { Challenge } from "./pages";
import DashboardIndex from "./pages/Auth/Dashboard";
import ViewProgress from "./pages/User/Customer/ViewProgress";
import NewChallenge from "./pages/NewChallengesManagers/ChallengeManagementFunctions";
import RewardsStoreIndex from "./pages/RewardsandStore/RewardsStore";
import ViewFeed from "./pages/Feed/ViewFeed";
import ViewSupport from "./pages/Support/View";
import UserChallengeProgress from "./pages/UserChallenge/ViewProgress";
import TnC from "./pages/Auth/TnC";

window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {
  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={true} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {
  return (

    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/login" element={<SignIn />} />
      {/* <Route path="/sign-up" element={<Register />} /> */}
      <Route path="/privacy_policy" element={<Privacy_policy />} />
      <Route path="/tnc" element={<TnC />} />
      <Route exact path="/dashboard-new" element={<DashboardIndex />} />
      <Route exact path="/new-challenge" element={<NewChallenge />} />
      <Route exact path="/reward-store" element={<RewardsStoreIndex />} />


      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        {/* Auth Routes */}
        <Route exact path="/" element={<Home />} />
        <Route exact path="/dashboard" element={<Home />} />
        <Route exact path="/profile" element={<Profile />} />

        {/* customer */}
        <Route exact path="/customer" element={<Customer />} />
        <Route exact path="/customer/view/:id" element={<CustomerView />} />
        <Route exact path="/customer/view/:id/progress" element={<ViewProgress />} />

        {/* challenge */}
        <Route exact path="/challenge" element={<Challenge />} />
        <Route exact path="/challenge/view-predefined/:id" element={<ViewPredefined />} />

        {/* user-challenge */}
        <Route exact path="/user-challenge" element={<UserChallenge />} />
        <Route exact path="/user-challenge/view/:id" element={<UserChallengeProgress />} />

        {/* feed */}
        <Route exact path="/feed" element={<Feed />} />
        <Route exact path="/feed/view/:id" element={<ViewFeed />} />

        {/* leaderboard */}
        <Route exact path="/leaderboard" element={<Leaderboard />} />

        {/* merchandize */}
        <Route exact path="/merchandize" element={<Merchandize />} />

        {/* coupon */}
        <Route exact path="/coupon" element={<Coupon />} />

        {/* subscription */}
        <Route exact path="/subscription" element={<Subscription />} />

        {/* sub admin */}
        <Route exact path="/sub-admin" element={<SubAdmin />} />
        <Route exact path="/sub-admin-role" element={<RoleManagement />} />

        {/* support manager */}
        <Route exact path="/support" element={<Support />} />
        <Route exact path="/support/:id" element={<ViewSupport />} />


        {/* cms manager */}
        <Route exact path="/cms" element={<CmsManagement />} />

        {/* notification */}
        <Route exact path="/notification" element={<Notifications />} />

        {/* email templates */}
        <Route exact path="/email-templates" element={<EmailTemplate />} />
        <Route exact path="/email-templates/:id/edit" element={<EmailEdit />} />

        {/* transaction */}
        <Route exact path="/transaction" element={<Transaction />} />



        <Route exact path="/content-media" element={<MediaContent />} />
        <Route exact path="/view-logs/:id?" element={<ViewLogs />} />
        <Route exact path="/order" element={<Order />} />

        {/* Category */}
        <Route exact path="/category" element={<Category />} />
        <Route exact path="/attribute" element={<Attribute />} />

        {/* Product Catalogue */}
        <Route exact path="/product" element={<Product />} />
        <Route exact path="/view-product/:id" element={<ViewProduct />} />
      </Route>

      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
